// checkout/utils/toggleState.ts

/**
 * Toggles the visibility or interactivity state of a given HTML element. Accepts 'hidden' or 'disabled' attributes.
 *
 * @param {HTMLElement} elems - The array of HTML elements to modify.
 * @param {'hidden' | 'disabled'} state - The state to toggle, either a 'hidden' or 'disabled' attribute.
 * @returns {void}
 */
export function toggleState(elems: HTMLElement[], state: 'hidden' | 'disabled'): void {
	elems.forEach((elem) => {
		switch (state) {
			case 'hidden':
				elem.hidden = !elem.hidden;
				break;
			case 'disabled':
				if ('disabled' in elem) {
					(elem as HTMLInputElement | HTMLButtonElement).disabled = !(
						elem as HTMLInputElement | HTMLButtonElement
					).disabled;
				}
				break;
		}
	});
}
